import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/client';
import { validaCF } from '../utils/codiceFiscale';

export default function Register() {
  const [form, setForm]           = useState({ nome: '', cognome: '', email: '', codice_fiscale: '', password: '', conferma: '' });
  const [accettaPrivacy, setAP]   = useState(false);
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);
  const navigate = useNavigate();

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));
  // Avviso immediato mentre si scrive; il controllo che conta lo rifà il server.
  const cfCompleto = form.codice_fiscale.replace(/\s+/g, '').length >= 16;
  const esitoCF = cfCompleto ? validaCF(form.codice_fiscale, form.nome, form.cognome) : null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const cf = validaCF(form.codice_fiscale, form.nome, form.cognome);
    if (!cf.valido) { setError(cf.errore); return; }
    if (form.password !== form.conferma) { setError('Le password non coincidono'); return; }
    if (form.password.length < 8) { setError('La password deve essere di almeno 8 caratteri'); return; }
    if (!accettaPrivacy) { setError("Devi accettare l'informativa privacy per registrarti."); return; }
    setLoading(true);
    try {
      await api.post('/auth/register', { nome: form.nome, cognome: form.cognome, email: form.email, codice_fiscale: form.codice_fiscale, password: form.password, accetta_privacy: true });
      navigate('/verify-email', { state: { email: form.email } });
    } catch(err) {
      setError(err.response?.data?.error || 'Errore durante la registrazione');
    } finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>B-CHEERS ASD</div>
        <div style={s.sub}>CREA IL TUO ACCOUNT</div>
        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.row}>
            <div style={s.field}>
              <label style={s.label}>NOME</label>
              <input style={s.input} value={form.nome} onChange={set('nome')} placeholder="Mario Luigi" required />
            </div>
            <div style={s.field}>
              <label style={s.label}>COGNOME</label>
              <input style={s.input} value={form.cognome} onChange={set('cognome')} placeholder="Rossi" required />
            </div>
          </div>
          <div style={{ fontSize: '12.5px', color: '#B45309', margin: '-4px 0 4px' }}>Scrivi nome e cognome come sul documento, compreso l'eventuale secondo nome: il codice fiscale si calcola su tutti i nomi.</div>
          <div style={s.field}>
            <label style={s.label}>EMAIL</label>
            <input style={s.input} type="email" value={form.email} onChange={set('email')} placeholder="mario@email.it" required />
          </div>
          <div style={s.field}>
            <label style={s.label}>CODICE FISCALE</label>
            <input style={{ ...s.input, textTransform:'uppercase', letterSpacing:'1px' }} value={form.codice_fiscale} onChange={set('codice_fiscale')} placeholder="RSSMRA80A01F205X" maxLength={20} autoComplete="off" required />
            {esitoCF && (esitoCF.valido
              ? (esitoCF.parziale ? <div style={s.hint}>Codice ben scritto: inserisci nome e cognome per completare il controllo</div> : <div style={s.cfOk}>✓ Codice fiscale corretto</div>)
              : <div style={s.cfKo}>{esitoCF.errore}</div>)}
            <div style={s.hint}>Serve a collegare l'account alla tua scheda di socio/corsista. Nome e cognome come sul documento.</div>
          </div>
          <div style={s.field}>
            <label style={s.label}>PASSWORD</label>
            <input style={s.input} type="password" value={form.password} onChange={set('password')} placeholder="Minimo 8 caratteri" required />
          </div>
          <div style={s.field}>
            <label style={s.label}>CONFERMA PASSWORD</label>
            <input style={s.input} type="password" value={form.conferma} onChange={set('conferma')} placeholder="Ripeti la password" required />
          </div>
          <div style={s.checkRow}>
            <input
              type="checkbox"
              id="accetta_privacy"
              checked={accettaPrivacy}
              onChange={e => setAP(e.target.checked)}
              style={s.checkbox}
            />
            <label htmlFor="accetta_privacy" style={s.checkLabel}>
              Ho letto e accetto l'<Link to="/privacy" target="_blank" style={s.link}>informativa privacy</Link> (obbligatorio)
            </label>
          </div>
          {error && <div style={s.error}>{error}</div>}
          <button type="submit" style={{ ...s.btn, opacity: (loading || !accettaPrivacy) ? 0.5 : 1 }} disabled={loading || !accettaPrivacy}>
            {loading ? 'REGISTRAZIONE...' : 'REGISTRATI'}
          </button>
        </form>
        <div style={s.footer}>
          Hai già un account? <Link to="/login" style={s.link}>Accedi</Link>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:      { minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' },
  checkRow:  { display:'flex', alignItems:'flex-start', gap:'10px', marginTop:'4px' },
  checkbox:  { marginTop:'3px', accentColor:'#F4600C', width:'16px', height:'16px', flexShrink:0, cursor:'pointer' },
  checkLabel:{ fontSize:'var(--font-size-sm)', color:'var(--text-dim)', lineHeight:'1.5', cursor:'pointer' },
  card:   { background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'16px', padding:'48px 40px', width:'100%', maxWidth:'440px' },
  logo:   { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', color:'#F4600C', letterSpacing:'3px', textAlign:'center', marginBottom:'4px' },
  sub:    { fontSize:'var(--font-size-xs)', fontWeight:'700', color:'var(--text-dim)', letterSpacing:'2px', textAlign:'center', marginBottom:'36px' },
  form:   { display:'flex', flexDirection:'column', gap:'16px' },
  row:    { display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' },
  field:  { display:'flex', flexDirection:'column', gap:'7px' },
  label:  { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'var(--text-dim)' },
  input:  { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'10px', padding:'12px 14px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
  cfOk:   { fontSize:'var(--font-size-xs)', color:'#22C55E', fontWeight:'600' },
  cfKo:   { fontSize:'var(--font-size-xs)', color:'#EF4444', fontWeight:'600' },
  hint:   { fontSize:'var(--font-size-xs)', color:'var(--text-dim)', lineHeight:'1.4' },
  error:  { background:'#EF444420', border:'1px solid #EF444440', borderRadius:'8px', padding:'10px 14px', color:'#EF4444', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  btn:    { background:'#F4600C', color:'#fff', border:'none', borderRadius:'10px', padding:'14px', fontSize:'var(--font-size-sm)', fontWeight:'700', cursor:'pointer', letterSpacing:'1px', marginTop:'4px' },
  footer: { textAlign:'center', marginTop:'20px', fontSize:'var(--font-size-sm)', color:'var(--text-dim)' },
  link:   { color:'#F4600C', textDecoration:'none', fontWeight:'700' },
};
